import "./state_tooltip.css"
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import {useTranslation} from "react-i18next";

function StateTooltipComponent() {

    const {t} = useTranslation()

    return (
        <>
            <OverlayTrigger
                placement='bottom'
                overlay={
                    <Tooltip id={`tooltip-bottom`}>
                        {t('tooltip.state_tooltip')}
                    </Tooltip>
                }
            >
                <div className="hover-text">
                    <span>{t('tooltip.state_tooltip_message')}</span>
                </div>
            </OverlayTrigger>
        </>
    );
}

export default StateTooltipComponent;